import { defineSlotRecipe } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: tabsAnatomy.keys(),
  variants: {
    variant: {
      enclosed: {
        list: {
          bg: 'colorPalette.subtle',
        },
        trigger: {
          color: 'colorPalette.solid',
          fontWeight: 'normal',
        },
      },
    },
  },
});
